class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    /* Corso is non dev friendly app that adds and remove a shipping protection product to the cart */
    if(this.dataset.corsoActive) {
      this.addEventListener('cart:updated:corso', this.cartCorsoListener.bind(this));
      this.cartCorsoListener();      
    }
  }

  connectedCallback() {
    this.productRecommendationsUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.setProductRecommendations.bind(this));
  }

  disconnectedCallback() {
    if (this.productRecommendationsUnsubscriber) {
      this.productRecommendationsUnsubscriber();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, corsoUpdate = false) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    if(!corsoUpdate) {
      this.productId = parsedState.id;
      parsedState = parsedState.sections;
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState[section.id], section.selector);
      });      
    } else  {
      [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer-Form',
        },
        {
          id: 'cart-drawer',
          selector: '.cart-drawer__footer',
        },
        {
          id: 'cart-drawer',
          selector: '.cart-count-bubble',
        },
        {
          id: 'cart-icon-bubble',
        },
      ].forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState[section.id], section.selector);
      });
    }

    setTimeout(() => {
      this.setProductRecommendations();
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if(!corsoUpdate) {
        this.open();
      }
      if(this.dataset.corsoActive) {
        this.cartCorsoListener();
      }
    });
  }

  setProductRecommendations() {    
    this.recommendedProducts = document.querySelector("[data-cart-recommended-products]");      
    if(this.recommendedProducts) {
      const renderCart = new Event('render-cart'); 
      this.recommendedProducts.dispatchEvent(renderCart);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  cartCorsoListener() {
    const bottomContent = this.querySelector(".drawer__footer");
    if(bottomContent) {
      const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (document.querySelector('.drawer__footer .gspa-price')) {
            const corsoInput = document.querySelector('.gspa-input-checkbox');
            if(corsoInput) {
              this.cartCorsoHelper();
              corsoInput.addEventListener('change', () => {
                this.cartCorsoHelper();
              })
              attrObserver.disconnect();
            }
          }
        });
      });
      attrObserver.observe(bottomContent, { childList: true});
    }
  }

  cartCorsoHelper() {
    setTimeout(() => {
      fetch('/?sections=cart-drawer,cart-icon-bubble')
        .then((response) => response.json())
        .then((response) => { this.renderContents(response, true) })
        .catch((e) => {
          console.error(e);
        })
    }, 3000)
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
